export const pageSizeEnums = {
  DEFAULT: 20,
  TEN: 10,
  FIFTY: 50,
};

export const orderStatusEnums = Object.freeze({
  NEW: 'NEW',
  PRESCRIBED: 'PRESCRIBED',
  ASSIGNED_RX: 'ASSIGNED_RX',
  NO_RX: 'NO_RX',
  REFUNDED: 'REFUNDED',
  UNCOMPLETED: 'UNCOMPLETED',
});
